import { render, staticRenderFns } from "./GoogleIntegration.vue?vue&type=template&id=0f4c8704&"
import script from "./GoogleIntegration.vue?vue&type=script&lang=js&"
export * from "./GoogleIntegration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports